'use client'
import React, { createContext, useContext, useState, ReactNode } from 'react'
import { User } from '../types'

type MyContextType = {
	user: User | null
	setUser: (data: User) => void
}

const UserContext = createContext<MyContextType | undefined>(undefined)

export const UserProvider = ({ children }: { children: ReactNode }) => {
	const [user, setUser] = useState<User | null>(null)

	return (
		<UserContext.Provider value={{ user, setUser }}>
			{children}
		</UserContext.Provider>
	)
}

export const useUser = () => {
	const context = useContext(UserContext)
	if (!context) {
		throw new Error('useUser must be used within a UserProvider')
	}
	return context
}
